import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ShareButton from "../common/ShareButton/ShareWhite";
import logoWhite from "../../assets/images/icons/logo4x.png";
// import logoWhite from '../../assets/images/unravel-logo.svg'
// import tripImage from "../../assets/images/trip-image-banner.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./index.css";
// import required modules
import { Pagination, Navigation } from "swiper";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  fetchCurrentState,
  // getTripData,
} from "../../redux/features/customerViewSlice";
// import {
//   getTripDataAsync,
//   postTripDataAsync,
// } from '../../redux/services/apiCalls'
// import ReactCountryFlag from 'react-country-flag'

// url query params
// import { useSearchParams } from 'react-router-dom'
// import { tripDataObj } from '../../trip_modified'
// import { dateRangeFormat, guestInfo, handleSession } from '../../util'
import { v4 } from "uuid";
import { fetchVideosImages } from "./customerViewDataModel";
import { isEmpty } from "lodash";
import rightArrow from "../../assets/images/icons/right-arrow.svg";
import { useRef } from "react";
import TextTruncate from "react-text-truncate";
import VideoCarousel from "./VideoCarousel";
import { useState } from "react";
import useGAEventTracker from "../common/customHooks/useGAEventTracker";
import { analyticsEvent, eventName } from "../common/Analytics/AnalyticsEvent";
import { NumericFormat } from "react-number-format";
import { Helmet } from "react-helmet";
import { getCurrencySymbol } from "../../util";

function CustomerView() {
  const navigate = useNavigate();

  const [isMuted, setisMuted] = useState(true);
  // const dispatch = useDispatch()
  console.log("Main>>> :: Rendered");

  // const [searchParams, setSearchParams] = useSearchParams()
  const tripStateData = useSelector(fetchCurrentState);
  // console.log(tripStateData)

  if (isEmpty(tripStateData)) {
    console.log(tripStateData);
    window.location.href = "/error";
  }
  const videoImages = fetchVideosImages(tripStateData.intro.videos);

  return (
    <>
      {!isEmpty(tripStateData) && (
        <div
          style={{
            height: "calc(var(--vh, 1vh) * 100)",
            position: "relative",
            // overflow: 'hidden',
          }}
        >
          <Helmet>
            <title>{tripStateData.display_name}</title>
            {/* <meta name="description" content="Lorem ipsum dolor sit amet" /> */}
          </Helmet>
          <div className="logo-container">
            <div>
              <img
                src={logoWhite}
                alt="logo"
                width={"141"}
                height={"auto"}
              ></img>
              {/* <logoWhite/> */}
            </div>
            <div
              className="share"
              onClick={() => {
                analyticsEvent.clickEvent(
                  "Intro",
                  eventName.Intro_share_opened
                );
              }}
            >
              <ShareButton
                eventName={eventName.Intro_share_success}
                category={"Intro"}
              ></ShareButton>
            </div>
          </div>

          <Swiper
            slidesPerView={1}
            // spaceBetween={30}
            loop={videoImages.length > 1 ? true : false}
            // pagination={{
            //   clickable: true,

            // }}
            // direction={'vertical'}
            grabCursor={true}
            onSlideNextTransitionEnd={() => {
              // console.log('Next Slide')
              analyticsEvent.clickEvent("Intro", eventName.Intro_right_swipe);
            }}
            // style={{ cursor: 'pointer' }}
            onSlidePrevTransitionEnd={() => {
              // console.log('Prev Slide')
              analyticsEvent.clickEvent("Intro", eventName.Intro_left_swipe);
            }}
            navigation={videoImages.length > 1 ? true : false}
            modules={[Pagination, Navigation]}
            className="mySwiper"
          >
            {videoImages.video.map((media, index) => {
              return (
                <SwiperSlide key={index}>
                  <VideoCarousel
                    media={media}
                    index={index}
                    isMuted={isMuted}
                    setisMuted={setisMuted}
                  />
                </SwiperSlide>
              );
            })}
            {videoImages.image.map((media) => {
              return (
                <SwiperSlide key={v4()}>
                  <div>
                    <img
                      src={media}
                      style={{
                        width: "100%",
                        height: "100vh",
                        objectFit: "cover",
                      }}
                      alt="intro"
                    ></img>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="trip-container">
            <div className="adjust-container-bottom">
              <div className="trip-items">
                <TextTruncate
                  line={2}
                  element="p"
                  truncateText="…"
                  text={tripStateData.display_name}
                  containerClassName="headline1"
                  style={{
                    // color: 'white',
                    lineHeight: "22.5px",
                  }}
                />
                {/* <p className="headline1">{tripStateData.display_name}</p> */}
              </div>
              {/* <div className="trip-items">
                <p className="body3">
                  {tripStateData.address.city
                    ? tripStateData.address.city
                    : tripStateData.address.country}
                  ,{' '}
                  {tripStateData.address.country
                    ? tripStateData.address.country
                    : tripStateData.address.continent}
                  &#160;&#160;
                  <span>
                    <ReactCountryFlag
                      countryCode={tripStateData.address.country_code}
                      svg
                    />
                  </span>
                </p>
              </div> */}
              <div className="trip-items">
                {
                  <p className="body3">
                    {/* {tripStateData.properties.trip_summary.start_date &&
                      tripStateData.properties.trip_summary.end_date && (
                        <span>
                          {dateRangeFormat(
                            tripStateData.properties.trip_summary.start_date,
                            tripStateData.properties.trip_summary.end_date,
                          )}
                          &nbsp;&#x2022;&nbsp;
                        </span>
                      )} */}
                    {tripStateData.properties.trip_summary.duration_days && (
                      <span>
                        {tripStateData.properties.trip_summary.duration_days}{" "}
                        Days&nbsp;&#x2022;&nbsp;
                      </span>
                    )}
                    {!isEmpty(tripStateData.properties.price) &&
                      !isEmpty(tripStateData.properties.price[0]) && (
                        <span className="headline2">
                          {getCurrencySymbol(
                            tripStateData.properties.price[0].unit
                          )}
                          <NumericFormat
                            value={tripStateData.properties.price[0].value}
                            thousandsGroupStyle="lakh"
                            thousandSeparator=","
                            displayType="text"
                            renderText={(value) => <b>{value}</b>}
                          />
                          {/* {tripStateData.properties.price[0].value} */}
                          &nbsp;
                        </span>
                      )}
                    {/* {!isEmpty(tripStateData.properties.guest_info) && (
                      <span>
                        &nbsp;&#x2022;&nbsp;
                        {guestInfo(
                          tripStateData.properties.guest_info[0].no_of_adults,
                          tripStateData.properties.guest_info[0].no_of_children,
                        )}
                      </span>
                    )} */}
                  </p>
                }
              </div>
              {/* <div className="trip-items">
                {!isEmpty(tripStateData.properties.price) &&
                  !isEmpty(tripStateData.properties.price[0]) && (
                    <p className="headline2">
                      <span style={{ color: '#E09804' }}>
                        {getCurrencySymbol(
                          tripStateData.properties.price[0].unit,
                        )}
                        {tripStateData.properties.price[0].value}&nbsp;
                      </span>
                      ({tripStateData.properties.price[0].unit})
                    </p>
                  )}
              </div> */}
              {/* <div
                className="trip-items"
                style={{ marginBottom: '5px', marginTop: '5px' }}
              >
                {!isEmpty(tripStateData.properties.tags) && (
                  <p className="body3">
                    {tripStateData.properties.tags
                      .toString()
                      .split(',')
                      .join(', ')
                      .toString()}
                  </p>
                )}
              </div> */}
              <div
                style={{
                  width: "100%",
                  // height: '85px',
                  // margin: 'auto',
                }}
              >
                <button
                  onClick={() => {
                    navigate("viewtrip");
                    analyticsEvent.clickEvent(
                      "Intro",
                      eventName.Intro_view_trip_details_click,
                      `TripName: ${tripStateData.display_name}, id: ${
                        tripStateData.item_id
                      }, duration: ${
                        tripStateData.properties.trip_summary.duration_days
                      }, price: ${
                        getCurrencySymbol(
                          tripStateData.properties.price[0].unit
                        ) + tripStateData.properties.price[0].value
                      }`
                    );
                  }}
                  className="button-view-trip"
                >
                  <span
                    style={{ display: "inline-flex" }}
                    className="headline2"
                  >
                    View your trip{" "}
                    <img src={rightArrow} alt="right-arrow"></img>{" "}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(CustomerView);
